<div class="no-hardware-info-container">

    <div class="section-header" bdFxLayoutAlign="space-between center">
        <div class="title">
            <span>{{infoData.title}}</span>

            <app-info-icon-button *ngIf="isInfoIconVisible()" [model]="{ title: 'Information',
                              messages: [getInfoIconText()],
                              dialogHeight: 100}">
            </app-info-icon-button>
        </div>
        <div (click)="onActivateItemsOrder()"
             class="no-hardware-btn" bdFxFlex
             bdFxLayoutAlign="end center">
            {{infoData.buttonTitle}}
        </div>
    </div>

    <div class="no-hardware-info-text" bdFxLayoutAlign="start center" >
        {{infoData.message}}
    </div>

</div>
